<template lang='pug'>
  i.svg-icon.svg-icon-translate
    svg(
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100')

      path(fill="#F18636" d="M23.19,51.31c0.74-0.11,1.44-0.18,2.1-0.23c0.66-0.05,1.4-0.08,2.2-0.08c0.7,0,1.38,0.03,2.05,0.08 c0.66,0.05,1.4,0.13,2.2,0.23l11.8,37.73c-1.43,0.21-2.83,0.32-4.19,0.32c-1.33,0-2.63-0.11-3.89-0.32l-2.1-7.55H20.89l-2.15,7.55 c-1.26,0.21-2.46,0.32-3.62,0.32c-1.3,0-2.57-0.11-3.83-0.32L23.19,51.31z M31.59,75.14l-4.36-15.85l-4.56,15.85H31.59z")

      path(fill="#0087BF" d="M15.01,36.95l-3.46-2.26l3.7,16.33l9.11-14.04l-3.29,0.75c5.15-11.39,16.42-18.81,29.21-18.81v-5.86 C34.54,13.06,20.73,22.54,15.01,36.95z")

      path(fill="#0087BF" d="M89,67.33l-3.7-16.32l-9.11,14.04l3.29-0.75c-5.15,11.39-16.42,18.81-29.21,18.81v5.86 c15.73,0,29.55-9.49,35.26-23.89L89,67.33z")

      path(fill="#44C1A9" d="M71.21,7c1.68,2.45,2.97,4.74,3.88,6.87l-3.44,1.94h16.07v5.14H82.6c-1.73,6.54-4.41,11.76-8.04,15.68 c3.78,2.53,8.6,4.16,14.44,4.88l-1.76,6.26c-6.93-0.92-12.61-3.34-17.03-7.26c-4.24,3.22-9.22,5.7-14.96,7.43l-3.24-5.53 c5.49-1.09,10.26-3.1,14.32-6c-3.71-4.58-6.37-9.73-8-15.46h-4.56v-5.14h14.6c-0.83-2.48-1.73-4.72-2.72-6.74L71.21,7z M64.05,20.95 c1.73,4.98,3.87,8.97,6.4,11.96c2.74-3.02,4.77-7.01,6.08-11.96H64.05z")


</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
}
</script>